import {HELP_DRAWER} from '@/store/mutation-types'

export default {

  setHelpPage(store, helpPage) {
    console.log('setHelpPage', helpPage);
    store
      .dispatch('setHelpPage', helpPage)
      .catch(err => {
        this.$emit('raison-event', { type: 'error', messages: [err.messages] });
      });
  },

  isHelpEnabled(path) {
    const exlusions = [
      '/login',
      '/register',
      '/profile'
    ]
    return !(exlusions.includes(path))
  },

  switchHelpDrawer(store) {
    store.commit(HELP_DRAWER)
  },

  clear(store) {
    this.setHelpPage(store, undefined)
  },

  findHelpPage(store, todo) {
    if(!todo) {
      return
    }

    var helpPage = todo.function
    if(todo.function === 'challenge_preference') {
      const hasGroups = todo
        && ( todo.preference.wigo.length > 1 || todo.preference.logo.length > 1 )
      if(hasGroups) {
        helpPage += '_with_groups'
      }
    }

    const hasContextualPreferences = todo && todo.contextualPreferences?.length > 0
    const hasContextualGroups = todo && todo.contextualGroups?.length > 0
    if(hasContextualPreferences || hasContextualGroups) {
      helpPage += '_with_alternatives'
    }
    console.log('todo', helpPage)
    this.setHelpPage(store, helpPage)
  }
};
